'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { OLAF, OZ_MEDIUM } from 'HubStyleTokens/colors';
import Controllable from '../decorators/Controllable';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import classNames from 'classnames';
import memoize from 'react-utils/memoize';
import SyntheticEvent from '../core/SyntheticEvent';
import UIButton from '../button/UIButton';
import UIIconCircle from '../icon/UIIconCircle';
import { uniqueId } from '../utils/underscore';
import lazyEval from '../utils/lazyEval';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
const FilePreviewLabel = styled.label.withConfig({
  displayName: "UIFileInput__FilePreviewLabel",
  componentId: "xp4fld-0"
})(["margin-left:12px;"]);
const getSuccessIcon = memoize(() => /*#__PURE__*/_jsx(UIIconCircle, {
  backgroundColor: OZ_MEDIUM,
  color: OLAF,
  name: "success",
  padding: 0.25,
  size: 9,
  verticalAlign: "text-top"
}));

class UIFileInput extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = evt => {
      const {
        onClick
      } = this.props;

      this._inputEl.click();

      if (onClick) onClick(evt);
    };

    this.handleFileSelect = evt => {
      const {
        onChange
      } = this.props;
      onChange(SyntheticEvent(evt.target.files[0], evt));
    };

    this._id = uniqueId('file-input-');
  }

  render() {
    const _this$props = this.props,
          {
      accept,
      buttonClassName,
      changeLabel,
      className,
      id,
      selectLabel,
      showFilePreview,
      use,
      value
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["accept", "buttonClassName", "changeLabel", "className", "id", "onChange", "onClick", "selectLabel", "showFilePreview", "use", "value"]);

    const computedId = id || this._id;
    return /*#__PURE__*/_jsxs("span", {
      className: classNames('private-file-button', className),
      children: [/*#__PURE__*/_jsx(UIButton, {
        className: buttonClassName,
        onClick: this.handleClick,
        use: use,
        children: lazyEval(value ? changeLabel : selectLabel)
      }), showFilePreview && value && /*#__PURE__*/_jsxs(FilePreviewLabel, {
        htmlFor: computedId,
        children: [getSuccessIcon(), " ", value.name]
      }), /*#__PURE__*/_jsx("input", Object.assign({}, rest, {
        accept: accept.join(','),
        className: "hidden",
        id: computedId,
        onChange: this.handleFileSelect,
        ref: ref => this._inputEl = ref,
        type: "file"
      }))]
    });
  }

}

UIFileInput.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string).isRequired,
  buttonClassName: PropTypes.string,
  changeLabel: createLazyPropType(PropTypes.node).isRequired,
  onChange: PropTypes.func,
  selectLabel: createLazyPropType(PropTypes.node).isRequired,
  showFilePreview: PropTypes.bool.isRequired,
  use: UIButton.propTypes.use,
  value: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.shape({
    name: PropTypes.string
  })])
};
UIFileInput.defaultProps = {
  accept: [],
  changeLabel: () => I18n.text('salesUI.UIFileInput.defaultChangeLabel'),
  selectLabel: () => I18n.text('salesUI.UIFileInput.defaultSelectLabel'),
  showFilePreview: true,
  use: 'secondary'
};
UIFileInput.displayName = 'UIFileInput';
export default Controllable(UIFileInput);